import { FilterOption } from '../../../../../ui-components/lib/filter-dropdown/filter-dropdown.model';
import { TableFilterTab } from '../../../../../ui-components/lib/table/table.model';
import { RequestTypeEnum } from '../../../../common/enums/request-type';
import { Insight } from '../../../../common/models/insight.model';
import { ActionList } from '../../../../common/models/action-list.model';
import { EMPLOYEE_ROUTES } from '../../../../common/constants/employee.routing.constants';
import { ENDPOINTS } from '../../../../common/constants/endpoints.constants';
import { StepStatusEnum } from '../../../../common/enums/step-status';
import {
  PARENT_TASKS_COLUMN_HEADER,
  RELATED_REQUESTS_COLUMN_HEADER,
  COLUMN_IDENTIFIERS,
} from '../../const';

export const ALL_PARTICIPATED_INSIGHTS: Insight[] = [
  {
    label: 'my_inbox_third_tab_first_insight_label',
    iconName: StepStatusEnum.INPROGRESS,
    value: '0',
  },
  {
    label: 'my_inbox_third_tab_second_insight_label',
    iconName: StepStatusEnum.COMPLETED,
    value: '0',
  },
  {
    label: 'my_inbox_third_tab_third_insight_label',
    iconName: StepStatusEnum.REJECTED,
    value: '0',
  },
  {
    label: 'my_inbox_third_tab_fourth_insight_label',
    iconName: 'hold',
    value: '0',
  },
];

export const ALL_PARTICIPATED_VIEW_DETAILS_ACTION: ActionList = {
  key: 'view_details',
  hasIcon: true,
  label: 'view_details_action_item',
  hasDivider: false,
  labelCustomStyle: '',
  hasToggle: false,
  toggleValue: false,
  isLink: true,
  routerLinks: [],
};

export const ALL_PARTICIPATED_ARCHIVE_ACTION: ActionList = {
  key: 'archive',
  hasIcon: true,
  label: 'archive_action_item_label',
  hasDivider: false,
  labelCustomStyle: 'text-destructive-500 text-xs',
  hasToggle: false,
  toggleValue: false,
  isLink: false,
};

export const ALL_PARTICIPATED_RESTORE_ACTION: ActionList = {
  key: 'restore',
  hasIcon: true,
  label: 'restore_action_item_label',
  hasDivider: false,
  labelCustomStyle: '',
  hasToggle: false,
  toggleValue: false,
  isLink: false,
};

export const ALL_PARTICIPATED_FILTER_OPTIONS: FilterOption[] = [
  {
    key: 'workflowTypes',
    label: 'assigned_to_me_filter_workflow_types_label',
    type: 'multi',
    apiUrl: ENDPOINTS.Lookup.FlowTemplates,
    placeholder: 'assigned_to_me_filter_workflow_types_placeholder',
  },
  {
    key: 'creationDate',
    label: 'all_participated_filter_creation_date_label',
    type: 'dateRange',
  },
  {
    key: 'projectIds',
    label: 'vendor_invoice_page_table_filter_option_product',
    type: 'multi',
    apiUrl: ENDPOINTS.Lookup.project,
    placeholder: 'vendor_invoice_page_table_filter_option_product_placeholder',
  },
  {
    key: 'resourceType',
    label: 'filter_resources_type_label',
    type: 'resourceType',
  },
];

export const ALL_PARTICIPATED_ON_HOLD_TABLE_FILTER_TABS: TableFilterTab[] = [
  {
    key: 'all',
    identifier: 'all',
    label: 'table_filter_tab_all_label',
    active: true,
    iconName: 'all',
  },
  {
    key: 'in_progress',
    identifier: 'inprogress',
    label: 'table_filter_tab_inprogress_label',
    active: false,
    iconName: 'inprogress',
  },
  {
    key: 'completed',
    identifier: 'completed',
    label: 'table_filter_tab_completed_label',
    active: false,
    iconName: 'completed',
  },
  {
    key: 'rejected',
    identifier: 'rejected',
    label: 'table_filter_tab_rejected_label',
    active: false,
    iconName: 'rejected',
  },
  {
    key: 'on_hold',
    identifier: 'on_hold',
    label: 'table_filter_tab_on_hold_label',
    active: false,
    iconName: 'hold',
  },
  {
    key: 'archived',
    identifier: 'archived',
    label: 'table_filter_tab_archived_label',
    active: false,
    iconName: 'archived',
  },
];

export const ALL_PARTICIPATED_ON_HOLD_COLUMNS = [
  { header: '' },
  {
    identifier: COLUMN_IDENTIFIERS.ID,
    header: 'all_participated_tab_id_header_title',
    showViewIcon: (row: any, permissionsService: any, appPermissions: any) => {
      return permissionsService.checkPermission(
        [appPermissions.workflow.view],
        row.permissions
      );
    },
    viewIconRouterLink: (row: any, tenantService: any) => [
      tenantService.tenantPath(
        `${EMPLOYEE_ROUTES.MY_INBOX.REQUEST}/${RequestTypeEnum.VIEW}/${row.id.toString()}`
      ),
    ],
    isSortable: true,
    sortKey: 'request_id][type',
  },
  {
    identifier: COLUMN_IDENTIFIERS.NAME,
    header: 'all_participated_tab_request_name_header_title',
    isSortable: true,
    sortKey: 'workflow_type][type',
  },
  {
    header: PARENT_TASKS_COLUMN_HEADER,
    isSortable: false,
  },
  {
    header: 'all_participated_tab_creation_date_header_title',
    isSortable: true,
    sortKey: 'creation_date][type',
  },
  {
    header: 'all_participated_tab_creator_header_title',
    isSortable: true,
    sortKey: 'creator][type',
  },
  {
    header: 'all_participated_tab_completion_date_header_title',
    isSortable: true,
    sortKey: 'completion_date][type',
  },
  {
    header: 'remaining_time_header_title',
    isSortable: false,
  },
  {
    identifier: COLUMN_IDENTIFIERS.REQUEST_SUBJECT,
    header: 'all_participated_tab_request_subject_header_title',
    isSortable: true,
    sortKey: 'request_subject][type',
  },
  {
    header: 'all_participated_tab_related_project_header_title',
    isSortable: true,
    sortKey: 'related_project][type',
  },
  {
    header: 'all_participated_tab_current_step_header_title',
    isSortable: true,
    sortKey: 'current_position][type',
  },
  {
    header: 'all_participated_tab_assignees_header_title',
    isSortable: true,
    sortKey: 'current_assignee_count][type',
  },
  {
    identifier: 'status',
    header: 'all_participated_tab_status_header_title',
    isSortable: true,
    sortKey: 'state][type',
  },
  {
    header: RELATED_REQUESTS_COLUMN_HEADER,
    isSortable: false,
  },
  { header: '' },
];
